/* eslint-disable react/display-name */
import React, { useMemo } from 'react';
import {
  ConfigStore,
  NamingAssetStore,
  NamingJsonStore,
  RedeemAssetStore,
  SettingsStore,
  TitleContentLayout,
  WalletStore,
  ZenJsUtils,
} from '@zen/common-app-parts';
import { useQuery } from 'react-query';
import RedeemBalance from './components/RedeemBalance/RedeemBalance';

export default function Balances() {
  const {
    state: { balances },
  } = WalletStore.useStore();

  const {
    state: {
      settings: { chain },
    },
  } = SettingsStore.useStore();

  const { state: naming } = NamingAssetStore.useStore();
  const { state: namingContract } = NamingJsonStore.useStore();

  const { contracts } = ConfigStore.useStore();
  const {
    state: {
      result: { redeemBalance },
    },
    actions,
  } = RedeemAssetStore.useStore();

  useQuery(
    ['Redeemable', balances, naming],
    () => actions.isBalancesRedeemable({ balances: balanceData, contracts, chain }),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      forceFetchOnMount: true,
    }
  );

  const balanceData = useMemo(
    () =>
      balances.map((data) => ({
        ...data,
        metadata: naming[data.asset] ? naming[data.asset] : { name: '', shortName: '' },
        metadataContract: namingContract[ZenJsUtils.getContractFromAsset(data.asset)]
          ? namingContract[ZenJsUtils.getContractFromAsset(data.asset)]
          : { name: '', shortName: '' },
      })),
    [balances, naming, namingContract]
  );

  return (
    <TitleContentLayout dark noPadding position="relative" title="Balances">
      <RedeemBalance balances={redeemBalance} chain={chain} />
    </TitleContentLayout>
  );
}
